import moment from 'moment';

// IMPORT PACKAGE REFERENCES

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { pad } from '../../Config/Helpers';

// COMPONENT

class PharmacyListItem extends React.Component {

    constructor(props) {
        super(props);
    }

    getLatestEvent(pharmacy) {
        if(pharmacy.hasOwnProperty("devices")) {
            let deviceKeys = Object.keys(pharmacy.devices);
            let times = []
            deviceKeys.forEach(deviceKey => {
                let device = pharmacy.devices[deviceKey];
                let event = this.getDeviceEvent(device);
                if (event !== undefined) {
                    times.push(event);
                }
            })

            let minTime = times.sort((time1, time2) => {
                if(time1[2] <= time2[2]) {
                    return -1;
                }
                else if (time1[2] == time2[2]) {
                    return 0;
                }

                return 1;
            })
            
            if (minTime[0] !== undefined) {
                minTime = minTime[0];
                return this.formatDate(minTime);
            }
        }
        return "-";
    }

    getLastTouched(pharmacy) {
        if(pharmacy.hasOwnProperty("devices")) {
            let deviceKeys = Object.keys(pharmacy.devices);
            let times = []
            deviceKeys.forEach(deviceKey => {
                let device = pharmacy.devices[deviceKey];
                let event = this.getLastTouchedEvent(device);
                if (event !== undefined) {
                    times.push(event);
                }
            })

            let minTime = times.sort((time1, time2) => {
                if(time1[2] <= time2[2]) {
                    return -1;
                }
                else if (time1[2] == time2[2]) {
                    return 0;
                }

                return 1;
            })

            if (minTime[0] !== undefined) {
                minTime = minTime[0];
                return this.formatDate(minTime);
            }
        }
        return "-";
    }

    getLastReport(pharmacy) {
        if(pharmacy.hasOwnProperty("devices")) {
            let deviceKeys = Object.keys(pharmacy.devices);
            let times = []
            deviceKeys.forEach(deviceKey => {
                let device = pharmacy.devices[deviceKey];
                let event = this.getLastReportEvent(device);
                if (event !== undefined) {
                    times.push(event);
                }
            })

            let minTime = times.sort((time1, time2) => {
                if(time1[2] <= time2[2]) {
                    return -1;
                }
                else if (time1[2] == time2[2]) {
                    return 0;
                }

                return 1;
            })

            if (minTime[0] !== undefined) {
                minTime = minTime[0];
                return this.formatDate(minTime);
            }
        }
        return "-";
    }

    getDeviceEvent(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            let timeStamp = device.DeviceDetails.DetailsTimestamp;
            if(timeStamp != undefined && timeStamp != null) {
                var now = moment(new Date()); //todays date
                var end = moment(timeStamp, "HH:mm:ss ddd DD-MM-YYYY"); // another date
                var duration = moment.duration(now.diff(end));
    
                var minutes = duration.asMinutes();
                var hours = duration.asHours();
                var days = duration.asDays();

                return [days, hours, minutes];
            }
        }
    }

    getLastReportEvent(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            let reportDetails = device.DeviceDetails.latest;
            let lastDate = reportDetails.Latest_ReportUploaded;

            if(reportDetails != undefined && reportDetails != null && lastDate != null) {
                var now = moment(new Date()); //todays date
                var end = moment(lastDate, "HH:mm:ss ddd DD-MM-YYYY"); // another date
                var duration = moment.duration(now.diff(end));
    
                var minutes = duration.asMinutes();
                var hours = duration.asHours();
                var days = duration.asDays();

                return [days, hours, minutes];
            }
        }
    }
        
    getLastTouchedEvent(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            let reportDetails = device.DeviceDetails.latest;
            if (device.hasOwnProperty("eventSummary")) {
                let reportStared = this.getEvent("ReportStarted", device.eventSummary);
                if (reportStared != null) {
                    var now = moment(new Date()); //todays date
                    var end = moment(reportStared.latest, "HH:mm:ss ddd DD-MM-YYYY"); // another date
                    var duration = moment.duration(now.diff(end));
        
                    var minutes = duration.asMinutes();
                    var hours = duration.asHours();
                    var days = duration.asDays();
        
                    return [days, hours, minutes];
                }
            }
        }   
    }

    getEvent(event, array) {
        var foundItem;
        array.forEach(function (item, index) {
            if(item.name === event) {
                foundItem = item;
            }
        });

        return foundItem;
    }

    getNumberOfAttachedDevices(pharmacy) {
        if (pharmacy.hasOwnProperty("deviceUuids")) {
            return Object.keys(pharmacy.deviceUuids).length;
        } else {
            return 0
        }
    }

    formatDate(date) {
        let days = date[0];
        let hours = date[1];
        let minutes = date[2];

        if (days < 1) {
            if (hours < 1) {
                if (minutes > 1) {
                    let rounded = Math.round(minutes)
                    return rounded + " minute" + (rounded == 1 ? "" : "s") +  " ago";
                }
                return "Just now";
            } else {
                let rounded = Math.round(hours)
                return Math.round(hours) + " hour" + (rounded == 1 ? "" : "s") +  " ago";
            }
        } else if (days != undefined && days != null){
            let rounded = Math.round(days)
            return rounded + " day" + (rounded == 1 ? "" : "s") +  " ago";
        }
        else {
            return "-";
        }
    }

    render() {
        const { pharmacy } = this.props;
        let properties = pharmacy.properties;

        return (
            <div className="list-item">
                <div className="row">
                    <div className="col">
                        <NavLink className="pharmacy-link" to={'/pharmacy/' + encodeURI(pharmacy.id)}>{ pharmacy.campaignName === "" ? "Unknown Pharmacy" : pharmacy.campaignName }</NavLink>
                    </div>
                    <div className="col">
                        <div className=" right-detail"><small className="text-muted">Active: { this.getLatestEvent(pharmacy) }</small></div> 
                        <div className=" right-detail"><small className="text-muted">Touched: { this.getLastTouched(pharmacy) }</small></div> 
                        <div className=" right-detail"><small className="text-muted">Report: { this.getLastReport(pharmacy) }</small></div>
                    </div>
                </div>
                <div>
                    <div className="device-tag">MDM ID { pad(pharmacy.mdmId, 3) }</div>

                    { properties.testPharmacy && <div className="device-tag test">Test</div> }
                    { properties.unattachedPharmacy && <div className="device-tag test">No devices attached</div> }
                    { properties.batteryLow && <div className="device-tag attention">Battery Low</div> }
                    { properties.deactivatedPharmacy && <div className="device-tag">Deactivated</div> }

                </div>
                {/* <div>{ this.getNumberOfAttachedDevices(pharmacy) }</div> */}
                
            </div>
        )
    }
}


PharmacyListItem.propTypes = {
    pharmacy: PropTypes.object.isRequired,
};

export default PharmacyListItem;